var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MenuList',{attrs:{"menuList":_vm.menuList,"showTippy":false},on:{"handleClicks":function($event){return _vm.clickMenu.apply(void 0, arguments)},"handleMouseenter":function($event){return _vm.handleMouseenter.apply(void 0, arguments)}}})}
var staticRenderFns = []

export { render, staticRenderFns }